<app-custom-modal #modal [title]="notificacao.titulo" [subtitle]="''" (onCloseClick)="modal.close()" [hideSave]="true" [hideCancel]="true">
    <div class="container">
        <p class="text-center">{{notificacao.mensagem}}</p>
        <div *ngIf="notificacao.token">
            <div *ngIf="tokenValido">
                <div *ngIf="notificacao.hasResposta == null">
                    <div class="d-flex justify-content-center align-items-center">
                        <button class="btn primary-gold-button mr-2" (click)="createResposta(true)">Liberar Acesso <i
                                class="hgi hgi-stroke hgi-tick-02"></i></button>
                        <button class="btn primary-white-button" (click)="createResposta(false)">Negar Acesso <i
                                class="hgi hgi-stroke hgi-multiplication-sign"></i></button>
                    </div>
                </div>
                <div *ngIf="notificacao.hasResposta == false">
                    <p class="text-center">Solicitação recusada. Para tentar novamente, solicite ao secretário(a) o
                        envio de um novo token.</p>
                </div>
            </div>
            <div *ngIf="notificacao.hasResposta == true">
                <div class="col-12 text-center token-container">
                    <p>{{notificacao.token}}</p>
                </div>
            </div>
            <div *ngIf="!tokenValido && notificacao.hasResposta == false">
                <p class="text-center">Token expirado. Para tentar novamente, solicite ao secretário(a) o envio de um novo token.</p>
            </div>
        </div>
    </div>
</app-custom-modal>